export const TO_BE_PUBLISH_STATUS = 3;
export const UNDER_REVIEW_STATUS = 4;
export const PUBLISH_STATUS = 6;
export const REJECT_STATUS = 7;
export const APP_WITHOUT_GUI = 9

export const mobileCapabilityList = [
  {
    mobileCapability: 7,
    mobileCapabilityName: "we码",
  },
  {
    mobileCapability: 8,
    mobileCapabilityName: "轻应用",
  },
  {
    mobileCapability: 9,
    mobileCapabilityName: "无界面",
  },
];

export const pcCapabilityList = [
  {
    pcCapability: 7,
    pcCapabilityName: "we码",
  },
  {
    pcCapability: 8,
    pcCapabilityName: "轻应用",
  },
  {
    pcCapability: 9,
    pcCapabilityName: "无界面",
  },
];


